import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { type PmpDealType, pmpDealType } from '@openx/types/deal.ts';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDealsLabels } from '../../../../DealForm/utils/dealFormUtils.ts';
import { useDealContext } from '../../../../utils/context/DealContext.tsx';

type OXSBuyerRenderProps = {
  pmpDealTypeValue: PmpDealType;
  buyerAccountId: string | null | undefined;
};

export const OXSBuyerRender = ({ pmpDealTypeValue, buyerAccountId }: OXSBuyerRenderProps) => {
  const { t } = useTranslation();
  const labels = getDealsLabels(t);
  const { useBuyerOrganizationsFetch } = useDealContext();

  const isPrivateAuction = pmpDealTypeValue === pmpDealType.PrivateAuction;

  const { data: oxsBuyers, isLoading } = useBuyerOrganizationsFetch(isPrivateAuction);

  const oxsBuyer = useMemo(
    () => oxsBuyers?.find(buyer => buyer.id === Number(buyerAccountId))?.name || '',
    [oxsBuyers, buyerAccountId]
  );

  return <FieldDetails loading={isLoading} title={labels.buyer_account_id} value={oxsBuyer} />;
};
